import React, { useState, useEffect } from "react";
import "./TransferHistory.css";
import { shareStates } from "./constants/enums.js";

import { getCookieTransferHistory } from "./helpers/Cookies";
import { getTransferDto } from "./constants/Requests";
import { apiGetParamsReplace, endpoints } from "./constants/services.constants";
import { useParams  } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { isRepublicaUser, formatBytes } from "./helpers/Tools";
 import { checkSessionToken } from './helpers/AuthHelper/AuthHelperV2';


export default function TransferDownload() {

  const {transferId} = useParams();


  const [title, setTitle] = useState("Henter information");
  const [message, setMessage] = useState("Vent et øjeblik...");
  const [loggedIn, setLoggedIn] = useState(false);

const [transferReady, setTransferReady] = useState(false);


  const navigate = useNavigate();

  function isGuid(value) {
    const guidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return guidRegex.test(value);
  }

  useEffect(() =>  {

    if(!isGuid(transferId)){
      setTitle("Link is not valid")
      setMessage("Please contact the links sender to get the correct one.")
      return;
    }

    const retryDelayMs = 5000;
    let retryTimeoutId;

    const fetchData = async () => {

      try {

        var dto = await getTransferDto(transferId);
        setLoggedIn(await checkSessionToken());

        var state = shareStates.find(s => s.id === dto.state)?.name;

        if(state == "Expired" || state == "Deleted"){
          setTitle("Link has expired")
          setMessage("Link has expired, please contact the links sender to get a new one.")
          return;
        }

        else if(state == "Active"){
          setTitle("Files are ready");
          setMessage(dto.title+".zip ("+formatBytes(dto.compressedSize)+")...");
          setTransferReady(true);
          return;
        }

        else if(state == "Processing"){
          setTitle("Files are not ready")
          setMessage("This page will update automatically when files are ready.")
          retryTimeoutId = setTimeout(fetchData, retryDelayMs);    
        }

        else{
          setTitle("Unknown status")
          setMessage("Please contact mbsupport@republica.dk with this information: " + transferId);
          return;
        }

      } catch (error) {
        setTitle("An error occured")
        setMessage("Please contact mbsupport@republica.dk with this information: "+transferId + " - "+error);
        return;
      }
    };

    fetchData();

    return () => {
      clearTimeout(retryTimeoutId);
    };


  }, []);




  function downloadfile(link){

      const a = document.createElement("a");
      a.href = link;
      document.body.appendChild(a);
      a.click();
      a.remove();
                
  }

  return (
    <div className="success-ts-body"

  style={{
    backgroundImage: 'url("/assets/background.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    minHeight: "100vh",
  }}

    >

      <div className="success-ts-page">
        <header className="success-ts-header">
          <a href="/">
            <img src="/assets/RepublicaTransfer-logo.png"  class="republica-logo"/>
          </a>
          {loggedIn &&
            <button className="history-btn" type="button" onClick={()=>{navigate("/history")}}>
              Transfer history
            </button>
          }

        </header>

        <main className="success-ts-content">
          <div className="success-ts-card">
            <h1 className="success-ts-title">{title}</h1>            
            <div className="success-ts-name-row">
              <span className="success-ts-shipment-name">{message}</span>
            </div>          
            {transferReady && 
            
             <button
                  className="transfer-rt-btn-primary"
                  type="submit"
                  id="transfer-rt-send-btn"
                  onClick={() => downloadfile(apiGetParamsReplace(endpoints.TRANSFER_DOWNLOAD, transferId))}
                >
                  Download files
                </button>
            
            }
          </div>
        </main>
      </div>
    </div>
  );
};
